module.exports = __webpack_public_path__ + "d5246e330d2c997e4cd0d7f6a7c0fc1c.svg";